'use strict';

$(document).ready(function() {

  $('.header__nav-toggle').click(function(){
    $('.header__nav').toggleClass('header__nav--open');
    $('.header').toggleClass('header--open');
  });
});